import { NodeType } from '../core/workflow/types'

/**
 * Filters available nodes based on source node's available connections
 * @param {CanvasWorkflowNode} sourceNode - The source node
 * @param {PaletteNode[]} availableNodes - List of available nodes
 * @returns {PaletteNode[]} Filtered list of nodes
 */
export const getCompatibleNodes = (sourceNode, availableNodes) => {
  const available_connections = sourceNode?.available_connections
  const isTemporary = sourceNode.type === NodeType.TEMPORARY

  if (isTemporary) {
    return availableNodes.filter(node => node.type !== NodeType.START)
  }

  if (available_connections.length === 0) {
    return availableNodes.filter(node => node.type !== NodeType.END)
  }

  const connectionsSet = new Set(available_connections)

  return availableNodes.filter(node => {
    if (node.type === NodeType.START) {
      return false
    }

    // check if sourceNode is start type, then not include end node in result
    if (sourceNode.type === NodeType.START && node.type === NodeType.END) {
      return false
    }

    // Check item_type, subtype, or type match using Set lookup
    return (
      connectionsSet.has(node.item_type) ||
      (node.subtype && connectionsSet.has(node.subtype)) ||
      connectionsSet.has(node.type)
    )
  })
}
